module.exports = __webpack_public_path__ + "07_bob_black.680cba1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/07_bob_black.png
// module id = HTPF
// module chunks = 0